export const createWebUserMutation = /* GraphQL */ `
  mutation createWebUser($webUser: WebUserInput!) {
    createWebUser(webUser: $webUser) {
      username
    }
  }
`;
